(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["balucards-cardmarket"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('balu-market-reviews')) {
  customElements.define('balu-market-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.bcm-review-track');
      this.track.querySelectorAll('[data-review-clone]').forEach((card) => card.remove());
      this.cards = [...this.track.children];
      this.count = this.cards.length;
      if (this.count < 2) return;
      this.button = this.querySelector('.bcm-review-toggle');
      this.window = this.querySelector('.bcm-review-window');
      this.status = this.querySelector('.bcm-review-position');
      this.positionLabel = this.querySelector('[data-review-position]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.manualPause = false;
      this.hovered = false;
      this.drag = null;
      const clone = this.cards[0].cloneNode(true);
      clone.dataset.reviewClone = 'true';
      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      this.track.append(clone);
      this.track.style.transform = 'translateX(0%)';
      this.classList.add('is-ready');
      this.querySelector('.bcm-review-controls').hidden = false;
      this.button.addEventListener('click', () => {
        this.manualPause = !this.manualPause;
        this.button.setAttribute('aria-pressed', String(this.manualPause));
        this.button.setAttribute('aria-label', this.manualPause ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.sync();
      }, { signal });
      this.querySelector('.bcm-review-prev').addEventListener('click', () => this.go(-1, true), { signal });
      this.querySelector('.bcm-review-next').addEventListener('click', () => this.go(1, true), { signal });
      this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, { signal });
      this.addEventListener('pointerleave', (event) => { if (event.pointerType === 'mouse') { this.hovered = false; this.sync(); } }, { signal });
      this.addEventListener('focusin', () => this.sync(), { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => { if (this.isConnected) this.sync(); }), { signal });
      this.window.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.go(event.key === 'ArrowRight' ? 1 : -1, true);
      }, { signal });
      this.window.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        this.drag = { x: event.clientX, y: event.clientY, id: event.pointerId };
        this.sync();
      }, { signal });
      window.addEventListener('pointerup', (event) => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const dx = event.clientX - this.drag.x;
        const dy = event.clientY - this.drag.y;
        this.drag = null;
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) this.go(dx < 0 ? 1 : -1, true);
        else this.sync();
      }, { signal });
      window.addEventListener('pointercancel', () => { this.drag = null; this.sync(); }, { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.animation?.finish();
        this.sync();
      }, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.cards.findIndex((card) => card === event.target || card.contains(event.target));
        if (index < 0) return;
        this.manualPause = true;
        this.button.setAttribute('aria-pressed', 'true');
        this.button.setAttribute('aria-label', this.button.dataset.playLabel);
        this.animation?.finish();
        this.go(index - this.index, true);
        this.sync();
      }, { signal });
      this.updateVisible(false);
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      const paused = this.manualPause || this.hovered || this.contains(document.activeElement) || this.reduced.matches || document.hidden || Boolean(this.drag);
      this.dataset.paused = String(paused);
      this.button.hidden = this.reduced.matches;
      if (!paused && !this.animation) this.timer = setTimeout(() => this.go(1, false), 5000);
    }
    updateVisible(manual) {
      this.dataset.activeIndex = String(this.index);
      this.cards.forEach((card, index) => {
        card.setAttribute('aria-hidden', String(index !== this.index));
        card.inert = index !== this.index;
      });
      this.status.setAttribute('aria-live', manual ? 'polite' : 'off');
      this.positionLabel.textContent = (this.index + 1) + ' / ' + this.count;
    }
    go(direction, manual) {
      clearTimeout(this.timer);
      if (this.animation || !direction) return;
      let from = this.index;
      let target = this.index + direction;
      if (target < 0) { from = this.count; target = this.count - 1; }
      const normalized = target % this.count;
      const start = 'translateX(' + (-from * 100) + '%)';
      const end = 'translateX(' + (-target * 100) + '%)';
      const finish = () => {
        this.animation = null;
        this.index = normalized;
        this.track.style.transform = 'translateX(' + (-normalized * 100) + '%)';
        this.dataset.moving = 'false';
        this.updateVisible(manual);
        this.sync();
      };
      this.track.style.transform = end;
      if (this.reduced.matches) { finish(); return; }
      this.dataset.moving = 'true';
      this.animation = this.track.animate([{ transform: start }, { transform: end }], { duration: 600, easing: 'ease-in-out' });
      this.animation.onfinish = finish;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.animation?.cancel();
      this.animation = null;
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balucards-newsletter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('balucards-newsletter')) {
  customElements.define('balucards-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const card = this.querySelector('.bn-signup');
      const media = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      if (!card || this.dataset.motion !== 'true') return;
      let bounds;
      const reset = () => {
        cancelAnimationFrame(this.frame);
        card.style.removeProperty('--bn-rx');
        card.style.removeProperty('--bn-ry');
      };
      card.addEventListener('pointerenter', () => { bounds = card.getBoundingClientRect(); }, { signal });
      card.addEventListener('pointermove', event => {
        if (!media.matches || card.contains(document.activeElement) || !bounds) return;
        cancelAnimationFrame(this.frame);
        const x = Math.max(-.5, Math.min(.5, (event.clientX - bounds.left) / bounds.width - .5));
        const y = Math.max(-.5, Math.min(.5, (event.clientY - bounds.top) / bounds.height - .5));
        this.frame = requestAnimationFrame(() => {
          card.style.setProperty('--bn-rx', (-y * 5).toFixed(2) + 'deg');
          card.style.setProperty('--bn-ry', (x * 5).toFixed(2) + 'deg');
        });
      }, { signal });
      card.addEventListener('pointerleave', reset, { signal });
      card.addEventListener('focusin', reset, { signal });
      media.addEventListener('change', reset, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
